import React, {FC} from "react";
import {AccommodationTypeDto} from "../../types/contracts";
import {AccommodationTypeFormComponentModal} from "../admin/AccomodationTypeFormComponentModal";
import {MdOutlineDelete} from "react-icons/md";
import {CiEdit} from "react-icons/ci";
import {useModal} from "../../hooks/useModal";

interface AccommodationTypesComponentProps {
    accommodationTypes: AccommodationTypeDto[];
    handleAccommodationTypeChange: (
        index: number,
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    removeAccommodationType: (index: number) => void;
    addAccommodationType: () => void;
    currency?: string;
    submittedAccommodationTypes: AccommodationTypeDto[];
}

const AccommodationTypesComponent: FC<AccommodationTypesComponentProps> = ({ accommodationTypes, handleAccommodationTypeChange, removeAccommodationType, addAccommodationType, currency, submittedAccommodationTypes }) => {
    const {isOpen: isModalOpen, openModal, closeModal} = useModal();

    return (
        <div className="mb-6">
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                Typy ubytování
                <CiEdit
                    onClick={openModal}
                    className="text-2xl cursor-pointer text-gray-600 hover:text-gray-800"
                />
            </h3>
            {accommodationTypes.map((accommodationType, index) => (
                <div
                    key={index}
                    className="flex justify-between mb-6 bg-gray-100 p-3 rounded-lg"
                >
                    <div className="flex flex-col">
                        <p className="flex items-center gap-2">
                            Název ubytování: {accommodationType.name}
                        </p>

                        <p>
                            Cena za{" "}
                            {accommodationType.isPricePerNight ? "jednu noc" : "pobyt"}:{" "}
                            {accommodationType.price} {currency}
                        </p>
                        <p>
                            Ubytování zajištěné samostatně:{" "}
                            {submittedAccommodationTypes[index]?.isSelfArrangedAccommodation ? "ano" : "ne"}
                        </p>
                        <p>
                            Skrýt ve formuláři (nedostupné):{" "}
                            {submittedAccommodationTypes[index]?.isHiddenInRegistration ? "ano" : "ne"}
                        </p>
                    </div>
                    <MdOutlineDelete
                        onClick={() => removeAccommodationType(index)}
                        className="text-red-500 rounded-md size-6 cursor-pointer"
                    />
                </div>
            ))}
            <AccommodationTypeFormComponentModal
                open={isModalOpen}
                onClose={closeModal}
                accommodationTypes={accommodationTypes}
                handleAccommodationTypeChange={handleAccommodationTypeChange}
                removeAccommodationType={removeAccommodationType}
                addAccommodationType={addAccommodationType}
            />
        </div>
    );
};

export default AccommodationTypesComponent;
